
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import { Card, CardContent, TableContainer, Paper, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import Select from 'react-select';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from 'react-router-dom';
import ArrowForward from '@mui/icons-material/ArrowForward';
import UndoIcon from '@mui/icons-material/Undo';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
const SaleReturnCreate = () => {
    const { id, tid } = useParams();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout]);

    const [customerId, setCustomerId] = useState('');
    const [customerOptions, setCustomerOptions] = useState([]);
    const [TripId, setTripId] = useState('');
    const [SaleId, setSaleId] = useState('');
    const [qty, setQty] = useState('');
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);
    const [saleData, setSaleData] = useState([]);
    //const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [invoiceData, setInvoiceData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [quantities, setQuantities] = useState([]);
    const [searchDate, setSearchDate] = useState('');
    const [RouteName, setRouteName] = useState('');
    const [filteredSaleData, setFilteredSaleData] = useState([]);
    const [highlightedRowIndex, setHighlightedRowIndex] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [lastChangedIndex, setLastChangedIndex] = useState(null);
    const [remark, setRemark] = useState("");


    const [combinedInvoiceData, setCombinedInvoiceData] = useState([]);

   
    // Fetching routes when the component is mounted
    useEffect(() => {
        fetchRouteTypes();
    }, []);

    // Function to fetch routes
    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name
                }));
                setRouteOptions(options); // Set available routes
            }
        } catch (error) {
            console.error('Error fetching routes:', error);
        }
    };

    // Function to handle route change and fetch customers based on selected route
    const handleRouteWiseCustomerChange = async (selectedOption) => {
        setSelectedRoute(selectedOption); // Update selected route
        setSelectedCustomer(null); // Reset customer selection when route changes

        try {
            const response = await fetchData('CustomerApi', `/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111') {
                const customerOptions = response.response_data.map(customer => ({
                    value: customer.id,
                    // label: customer.name + '' + customer.addressLine1  + '' +  customer.customerCode
                    label: `${customer.name} ${customer.addressLine1} ${customer.customerCode}` // Adding spaces between words
                }));
                setCustomerOptions(customerOptions); // Set customers based on route
            }
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };


    // pic customers wise invoice date
    const handleCustomerTypeChange = async (selectedOption) => {
        setSelectedCustomer(selectedOption);

        const response = await fetchData('SaleReturnApi', `/${companyId}/${selectedOption.value}`, token);
        setQuantities("");
        setSaleData([]);
        setFilteredSaleData([]);
        setCombinedInvoiceData([]);
        if (response.responseCode === '1111') {
            const dataArray = response.response_data;
            const sortedData = response.response_data.sort((a, b) => new Date(b.invoiceDate) - new Date(a.invoiceDate));
            setSaleData(sortedData);
            // setTripId(dataArray[0].tripID)
            setFilteredSaleData(sortedData);
            //setRouteName(dataArray.route)
            setQuantities(new Array(sortedData.length).fill(''));
            setShowModal(true);
        }
    };
    const closeModal = () => {
        setShowModal(false);
    };
    const handleInvoiceButton = () => {
        setShowModal(true)
    };

 

    const handleInvoiceClick = async (invoice) => {
        try {
            const response = await fetchData('SaleReturnApi', `/SaleReturn/${invoice.id}`, token);
            if (response.responseCode === '1111') {
                const invoiceData = response.response_data;
                setSelectedInvoices(prevSelectedInvoices => {
                    const isSelected = prevSelectedInvoices.some(inv => inv.id === invoice.id);
                    if (isSelected) {
                        return prevSelectedInvoices.filter(inv => inv.id !== invoice.id);
                    } else {
                        return [...prevSelectedInvoices, { id: invoice.id, data: invoiceData }];
                    }
                });
            }
        } catch (error) {
            console.error('Error fetching invoice data:', error);
        }
    };

    // Return Qty 
    const handleQuantityChange = (index, newValue) => {
        setLastChangedIndex(index);
        const updatedQuantities = [...quantities];
        updatedQuantities[index] = newValue;
        setQuantities(updatedQuantities);
        setHighlightedRowIndex(index);
    };


    const handleHistoryClick = async (saleid) => {
        try {
            const response = await fetchData('SaleReturnApi', `/SaleReturn/${saleid}`, token);
            if (response.responseCode === '1111') {
                setInvoiceData(response.response_data);
                setShowModal(true);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };


    const handleCategoryChange = async (selectedOption) => {
        setSelectedCustomer(selectedOption);
        try {
            // Assuming selectedOption.value contains the CustomerId
            const params = `/${selectedOption.value}`;
            const response = await fetchData('ReturnApprovalApi', params, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;
                setRouteName(dataArray.routename);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }
        setSelectedCategory(selectedOption);
        handleCustomerTypeChange(selectedOption);
        setSelectedCustomer(selectedOption);
        setCustomerId(selectedOption.value);
        setSelectedItem(null);
    };

    const handleRefreshClick = () => {

        // setToDate(getCurrentDate());
        // fetchData();
        window.location.reload();
    };

    const truncate2 = (num) => Math.trunc(num * 100) / 100;

    // calculation {gst, taxable values...........}
    function calculateTotalAmount(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
        const cgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
        const sgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
        const igstAmount = 0;
        const totalAmount = taxableAmount + cgstAmount + sgstAmount + igstAmount;
        return isNaN(totalAmount) ? 0 : Math.round(totalAmount);

    }

    function calculateGst(rapeperpeice, gstrate, quantities, bagweight) {
        const cgstAmount = calculateCGST(rapeperpeice, gstrate, quantities, bagweight);
        const sgstAmount = calculateSGST(rapeperpeice, gstrate, quantities, bagweight);
        const igstAmount = 0;
        const gst = cgstAmount + sgstAmount + igstAmount;
        return isNaN(gst) ? 0 : truncate2(gst).toFixed(2);

    }

    function calculateCGST(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
        const cgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
        return cgstAmount;
    }

    function calculateSGST(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
        const sgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
        return sgstAmount;
    }

    function taxableAmount(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
        return isNaN(taxableAmount) ? 0 : taxableAmount.toFixed(2);

    }

    const [newItem, setNewItem] = useState({
        Id: '',
        quantity: 1,
    });

    const [itemList, setItemList] = useState([]);
    const AddtoListdata = (e) => {
        e.preventDefault();
        const updatedItem = { quantity: parseInt(qty) };
        setItemList([...itemList, updatedItem]);
        setNewItem({
            quantity: 1,
        });
        setSelectedItem(null);
        setQty('');
    };
    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    useEffect(() => {
        const data = selectedInvoices.flatMap(invoice => invoice.data || []);
        setCombinedInvoiceData(data);
    }, [selectedInvoices]);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedSelectedInvoices = selectedInvoices.filter((_, i) => i !== itemToDeleteIndex);
            setSelectedInvoices(updatedSelectedInvoices);
            setItemToDeleteIndex(null);
            closeConfirmDialog();
        }
    };
  


    // invoice date search
    const handleSearch = () => {
        const filteredData = saleData.filter(item => {
            const invoiceDate = new Date(item.invoiceDate).toLocaleDateString('en-GB');
            return invoiceDate.includes(searchDate);
        });
        setFilteredSaleData(filteredData);
    };

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Create a SaleReturn object with required fields
        const saleReturnData = {
            TripId: parseInt(TripId),
            CustomerId: customerId,
            ReturnDate: new Date(),
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
            SaleID: SaleId || null,
            ReturnNo: 0,
            Remark: remark,
            ItemName: combinedInvoiceData.find(item => item.ItemId === SaleId)?.ItemName || 'Unknown',
            
        };
      
        // Create an array to hold sale return details
        const saleReturnDetails = [];

        // Iterate through quantities to include only highlighted or non-zero quantities
        quantities.forEach((quantity, index) => {
            if (quantity && quantity > 0) {
                const item = combinedInvoiceData[index];
                saleReturnDetails.push({
                    CustomerId: customerId,
                    CompanyId: companyId,
                    Rate: item.Rate,
                    RQuantity: parseInt(quantity),
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                    SaleID: item.SaleID,
                    TripID: parseInt(TripId),
                    SRate: item.TotalAmount,
                    SQuantity: item.Quantity,
                    ItemId: item.ItemId,
                    GSTRate: item.GSTRate,
                    ItemName: item.ItemName,
                    Item: item.ItemName,
                    DiscountAmount: item.DiscountAmount,
                    DiscountPerkg: item.DiscountPerPiece,
                    Bagweight: item.BagWeight,
                    RateperKg: item.RatePerKg,
                    RateAfterDiscount: item.RateAfterDiscount,
                  

                });
            }
        });

        // Create data object with saleReturn and saleReturnDetails
        const CreateData = {
            SaleReturn: saleReturnData,
            SaleReturnDetails: saleReturnDetails,
        };


        try {
            const response = await postData('SaleReturnApi', CreateData, token);
            console.log('Sale Return success:', response);
            setQuantities(Array(combinedInvoiceData.length).fill(""));
            setSuccessMessages("Sale Return successfully!");
            setErrorMessages("");
            window.location.reload();
            setTimeout(() => {
                setSuccessMessages("");
            }, 3000);
        } catch (error) {
            console.error('Sale Return error:', error);
            setIsLoading(false);

        }
    };
    //scroll
    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: 130,
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            msOverflowStyle: 'none',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: 130,
            overflowY: 'auto',
            '::-webkit-scrollbar': {
                width: '8px',
            },
            '::-webkit-scrollbar-thumb': {
                background: '#ccc',
                borderRadius: '4px',
            },
        }),
    };
    return (
        <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto', maxWidth: '98%' }}>
            <style>
                {`
            .container::-webkit-scrollbar {
              width: 0.1em;
            }
            .container::-webkit-scrollbar-track {
              background: rgba(255,255,255,0);
            }
            .container::-webkit-scrollbar-thumb {
              background-color: rgba(255,255,255,0);
              border-radius: 4px;
            }
          `}
            </style>

            <div>
                <div className="w-full sm:w-full mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>

                    <CardContent>
                        <div>
                        <h6 className="uppercase tracking-wide text-black flex-grow linkcolor"
                         style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontSize: '16px' }}>Sale Return Create</h6>
                        </div>
                        <div style={{ marginTop: '-35px', marginLeft: '45%' }}>
                            <h6 className="uppercase tracking-wide text-brown flex-grow linkcolor"
                             style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown' }}>Route : {RouteName}</h6>
                        </div>
                        <div className="flex mb-2" style={{ justifyContent: "flex-end" }}>
                            <Tooltip title="Exit">
                                <Link to="/SaleReturnIndex">
                                    <Button variant="contained" color="error" style={{ marginLeft: '10px' }}>
                                        Back
                                    </Button>
                                </Link>
                            </Tooltip>

                            &nbsp;&nbsp;&nbsp;

                            <Button onClick={handleInvoiceButton} style={{ backgroundColor: 'darkmagenta',  color: 'white' }} >
                                <CalendarMonthIcon style={{ fontWeight: 'bolder' }} />
                                Sale Date
                            </Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button onClick={submitData} style={{ backgroundColor: 'darkgreen', color: 'white'}} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} 
                            </Button>

                        </div>
                        <div className='w-full mb-1' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <div className="w-full sm:w-1/5 pl-2  sm:block">
                                <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="customer">
                                    Route
                                    <span className="text-red-500">*</span>
                                </label>
                                <Select
                                    value={selectedRoute}
                                    onChange={handleRouteWiseCustomerChange}
                                    options={routeOptions}
                                    placeholder="Select Route"
                                    isSearchable
                                />
                            </div>


                            <div className="w-full sm:w-1/3 pl-2  sm:block">
                                <label className="block tracking-wide text-black text-base font-medium mb-2" htmlFor="customer">
                                    Customer
                                    <span className="text-red-500">*</span>
                                </label>

                                <Select
                                    options={customerOptions}
                                    value={selectedCustomer}
                                    onChange={handleCategoryChange}
                                    placeholder="Select a Customer"
                                    styles={customStyles}
                                    isSearchable
                                />
                            </div>
                          
                            <Tooltip title="Refresh">
                                <Button onClick={handleRefreshClick} startIcon={<RefreshIcon />} style={{ marginTop: '30px', marginLeft: '-20px' }} >
                                </Button>
                            </Tooltip>
                          
                            <div className="mr-2" style={{ width: '300px' }}>
                                <label className="block tracking-wide text-black text-base  mb-2" htmlFor="remark">
                                    Remark
                                </label>
                                <select
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={remark}
                                    onChange={(e) => setRemark(e.target.value)}
                                >
                                    <option value="" disabled>Select Remark</option>
                                    <option value="Order Cancellation">Order Cancellation</option>
                                    <option value="Additional Order Return">Additional Order Return</option>
                                    <option value="Extra Loading Return">Extra Loading Return</option>
                                    <option value="Old Sale Return">Old Sale Return</option>
                                </select>
                            </div>


                        </div>

                        <div className="w-full mb-4 flex" style={{ maxHeight: '400px' }}>
                            <TableContainer component={Paper}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '50px' }}>Sl.No</th>
                                            <Tooltip title="Sale Date"><th style={{ width: '50px' }}>S.Date</th></Tooltip>
                                            <Tooltip title="Sale Bill Number"><th>Bill No</th></Tooltip>
                                            <Tooltip title="Item Name"><th>Name</th></Tooltip>
                                            <Tooltip title="Rate"><th>Rate<p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(per piece)</p></th></Tooltip>
                                            <th>Discount</th>
                                            <Tooltip title="Sale Rate"><th>Rate <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(after discount)</p></th></Tooltip>
                                            <Tooltip title="Sale Quantity"><th>S.Qty <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(No.of pieces) </p></th></Tooltip>
                                            <th>GST %</th>
                                            <Tooltip title="Return Quantity"><th>R.Qty <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(No.of pieces)</p></th></Tooltip>
                                            <Tooltip title="Total Quantity"><th>Total Qty <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(KGS)</p></th></Tooltip>
                                            <Tooltip title="Return Rate"><th>R.Rate</th></Tooltip>
                                            <Tooltip title="Taxable Amount"><th>Taxable Amt</th></Tooltip>
                                            <th>GST</th>
                                            <Tooltip title="Net Amount"><th>Net Amt</th></Tooltip>
                                            {/* <th>Delete</th> */}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {combinedInvoiceData && combinedInvoiceData.map((item, index) => (
                                            <tr key={index}>
                                                <td className=" border-r">{index + 1}</td>
                                                <td className=" border-r"> {item.invoiceDate ? new Date(item.invoiceDate).toLocaleDateString('en-GB') : ''}</td>
                                                <td className=" border-r">{item.prefix}{item.InvoiceNo}/{item.FinYear}</td>
                                                <td className=" border-r">{item.ItemName}</td>
                                                <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{item.RatePerKg.toFixed(2)}</td>
                                                <td className="border-r" style={{ textAlign: 'right' }}>
                                                    {item.DiscountPerPiece.toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r" style={{ textAlign: 'right', width: '80px' }}>{item.RateAfterDiscount.toFixed(2)}</td>
                                                <td className="border-r" style={{ textAlign: 'right' }}>{item.Quantity}</td>
                                                <td className="border-r" style={{ textAlign: 'right' }} >{item.GSTRate}</td>
                                                <td className="border-r" style={{ padding: '1px', fontSize: '14px', textAlign: 'right', width: '80px' }}>



                                                    <input
                                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                        style={{ backgroundColor: quantities[index] > 0 ? '#FFD6D1' : 'inherit', width: '80px', textAlign: 'right' }}
                                                        value={quantities[index]}
                                                        onFocus={() => setHighlightedRowIndex(index)}
                                                        onBlur={() => setHighlightedRowIndex(null)}
                                                        onChange={(e) => {
                                                            const input = e.target.value.replace(/\D/g, '');
                                                            if (input.length <= 4) {
                                                                const newQuantity = parseInt(input, 10);
                                                                handleQuantityChange(index, input);

                                                            }
                                                        }}
                                                        type="text"
                                                        min="0"
                                                    />
                                                </td>
                                                <td className="border-r" style={{ textAlign: 'right', width: '100px' }}>{isNaN(item.BagWeight * quantities[index]) ? '0' : (item.BagWeight * quantities[index])}</td>
                                                <td className="border-r" style={{ textAlign: 'right', width: '80px' }}>{(item.RateAfterDiscount).toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{isNaN(taxableAmount(item.RateAfterDiscount, item.GSTRate, quantities[index], item.BagWeight)) ? '0.00' : taxableAmount(item.RateAfterDiscount, item.GSTRate, quantities[index], item.BagWeight)}</td>
                                                <td className="border-r" style={{ textAlign: 'right', width: '80px' }}>{isNaN(calculateGst(item.RateAfterDiscount, item.GSTRate, quantities[index], item.BagWeight)) ? '0.00' : calculateGst(item.RateAfterDiscount, item.GSTRate, quantities[index], item.BagWeight)}</td>
                                                <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{isNaN(calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, quantities[index], item.BagWeight)) ? '0.00' : calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, quantities[index], item.BagWeight)}</td>
                                                {/* <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{(item.Rate * quantities[index]).toFixed(2)}</td>
                                                    <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{calculateTotalAmount(item.Rate, item.GSTRate, quantities[index])}</td>
                                                    */}
                                                {/* <td className="border-r">
                                                    <Tooltip title="Delete">
                                                        <DeleteIcon
                                                            style={{ color: 'violet', cursor: 'pointer', marginLeft: '20px' }}
                                                            onClick={() => openConfirmDialog(index)}
                                                        />
                                                    </Tooltip>
                                                </td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr >
                                            <td className="border-r text-left text-sm " colSpan="4" style={{ backgroundColor: 'rgb(190 242 225)' }}>Total</td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{combinedInvoiceData.reduce((acc, item) => acc + item.ItemRatePerKg, 0).toFixed(2)}</td>
                                            <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{combinedInvoiceData.reduce((acc, item) => acc + item.DiscountPerPiece, 0).toFixed(2)}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{combinedInvoiceData.reduce((acc, item) => acc + item.RateAfterDiscount, 0).toFixed(2)}</td>
                                            <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{combinedInvoiceData.reduce((acc, item) => acc + item.Quantity, 0)}</td>
                                            <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{combinedInvoiceData.reduce((acc, item) => acc + item.GSTRate, 0)}</td>
                                            <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                {combinedInvoiceData.reduce((acc, item, idx) => acc + (parseInt(quantities[idx]) || 0), 0)}
                                            </td>
                                            {/* <td className="border-r text-right text-sm">{filteredDatatable.reduce((acc, item, idx) => acc + (RQuantities[idx] || 0), 0)}</td> */}
                                            <td className=" border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)', textAlign: 'right' }}>

                                                {combinedInvoiceData.reduce((acc, item, idx) => {
                                                    const weight = Number(item.ItemBagWeight);
                                                    const qty = quantities[idx];
                                                    if (!isNaN(weight) && !isNaN(qty)) {
                                                        return acc + (weight * qty);
                                                    }
                                                    return acc;
                                                }, 0)}
                                            </td>
                                            <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{combinedInvoiceData.reduce((acc, item) => acc + item.RateAfterDiscount, 0).toFixed(2)}</td>

                                            <td className="px-4 py-2  border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                {combinedInvoiceData.reduce((acc, item, idx) => acc + parseFloat(taxableAmount(item.RateAfterDiscount, item.GSTRate, quantities[idx], item.ItemBagWeight)), 0).toFixed(2)}
                                            </td>
                                            <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                {combinedInvoiceData.reduce((acc, item, idx) => acc + parseFloat(calculateGst(item.RateAfterDiscount, item.GSTRate, quantities[idx], item.ItemBagWeight)), 0).toFixed(2)}
                                            </td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                {combinedInvoiceData.reduce((acc, item, idx) => acc + parseFloat(calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, quantities[idx], item.ItemBagWeight)), 0).toFixed(2)}
                                            </td>

                                            <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}></td>
                                        </tr>
                                    </tfoot>
                                </table>
                                <Dialog
                                    open={confirmDialogOpen}
                                    onClose={closeConfirmDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            Are you sure you want to delete this record?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <button
                                            onClick={closeConfirmDialog}
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: '#ffffff',
                                                border: '1px solid #dc3545',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                                marginRight: '8px',
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleDelete}
                                            style={{
                                                backgroundColor: '#28a745',
                                                color: '#ffffff',
                                                border: '1px solid #28a745',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Confirm
                                        </button>
                                    </DialogActions>
                                </Dialog>
                            </TableContainer>
                        </div>
                    </CardContent>
                </div>

                {selectedCategory && (
                    <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                        <div className="fixed inset-0 flex items-start justify-center z-10 ">
                            <div className="bg-green-100  p-6 rounded-lg shadow-lg" style={{ width: '700px', maxHeight: '70vh', overflowY: 'auto', overflowX: 'auto' }}>
                                <div className="flex justify-end mt-2">
                                    <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-20px', color: 'black' }}>
                                        <Tooltip title="Close">
                                            <FaTimes />
                                        </Tooltip>
                                    </button>
                                </div>
                                <Card className="w-full sm:w-1/2 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                                    <CardContent>
                                        <div>
                                            <h2 className="text-lg font-bold">{selectedCategory.label}</h2>
                                        </div>
                                        <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <input
                                                type="text"
                                                placeholder="Search by date (DD/MM/YYYY)"
                                                value={searchDate}
                                                onChange={(e) => {
                                                    setSearchDate(e.target.value);
                                                    handleSearch(e.target.value);
                                                }}
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline mb-2"
                                            />
                                            {filteredSaleData && filteredSaleData.map((item, index) => (
                                                <Card key={index} className="customCard" style={{ marginBottom: '10px', backgroundColor: selectedInvoices.some(inv => inv.id === item.id) ? '#50C878' : '', color: 'white', cursor: 'pointer' }} onClick={() => handleInvoiceClick(item)}>
                                                    <CardContent style={{ height: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <a href="#" className="tooltip-link" style={{ color: 'black' }}>
                                                            Date: {item.invoiceDate && new Date(item.invoiceDate).toLocaleDateString('en-GB')}
                                                        </a>

                                                    </CardContent>
                                                </Card>
                                            ))}
                                        </div>
                                    </CardContent>
                                </Card>
                            </div>
                        </div>
                    </Modal>
                )}
            </div>
        </div>
    );
};

export default SaleReturnCreate;
